import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const user = {
  namespaced: true,
  state: {
    userInfo: {
      uuid: "",
      nickName: "",
      headerImg: "",
      authority: ""
    },
    token: "",
    expiresAt: ""
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setToken(state, token) {
      state.token = token
    },
    setExpiresAt(state, expiresAt) {
      state.expiresAt = expiresAt
    },
    LoginOut(state) {
      state.userInfo = {}
      state.token = ""
      state.expiresAt = ""
      sessionStorage.clear()
      window.location.href = '/#/login'
    }
  },
  actions: {
    async LoginIn({ commit }, loginInfo) {
      const res = await login(loginInfo)
      commit('setUserInfo', res.data.user)
      commit('setToken', res.data.token)
      commit('setExpiresAt', res.data.expiresAt)
      if (res.code == 0) {
        sessionStorage.setItem('token', res.data.token)
        sessionStorage.setItem('userInfo', JSON.stringify(res.data.user))
        return res
      }
    },
    async LoginOut({ commit }) {
      const res = await jsonInBlacklist()
      if (res.code == 0) {
        commit("LoginOut")
      }
    }
  },
  getters: {
    userInfo(state) { return state.userInfo },
    token(state) { return state.token },
    expiresAt(state) { return state.expiresAt }
  }
}

// 从 sessionStorage 恢复登录态
const savedToken = sessionStorage.getItem('token')
const savedUser = sessionStorage.getItem('userInfo')
if (savedToken) {
  user.state.token = savedToken
}
if (savedUser) {
  try { user.state.userInfo = JSON.parse(savedUser) } catch(e) {}
}

// 需要导入 login 和 jsonInBlacklist，通过 actions 中的 this 自动获取
import { login, jsonInBlacklist } from '@/api'

export default new Vuex.Store({
  modules: { user }
})
